import React, { useState } from "react";
import { Group, Button, Title, Box, Divider } from "@mantine/core";
import { UserPlus } from "tabler-icons-react";
import EmployeeGrid from "./memberListing";

export function Employees() {
  const [opened, setOpened] = useState(false);
  return (
    <Box p="lg">
      <Group position="apart" mb="md">
        <Title order={2}>Employees</Title>
        <Group>
          <Button
            leftIcon={<UserPlus size={16} />}
            onClick={() => setOpened(true)}
          >
            Add Employees
          </Button>
          <Button onClick={() => setOpened(true)}>Status</Button>
        </Group>
      </Group>
      <Divider mb="md" />
      <EmployeeGrid />
    </Box>
  );
}
